import { render, staticRenderFns } from "./setSkip.vue?vue&type=template&id=84a5aa92&scoped=true"
import script from "./setSkip.vue?vue&type=script&lang=js"
export * from "./setSkip.vue?vue&type=script&lang=js"
import style0 from "./setSkip.vue?vue&type=style&index=0&id=84a5aa92&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a5aa92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84a5aa92')) {
      api.createRecord('84a5aa92', component.options)
    } else {
      api.reload('84a5aa92', component.options)
    }
    module.hot.accept("./setSkip.vue?vue&type=template&id=84a5aa92&scoped=true", function () {
      api.rerender('84a5aa92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/setSkip.vue"
export default component.exports